import { Button, Center, Loader, Paper, Stack, Text, ThemeIcon, Title } from '@mantine/core';
import { IconLock } from '@tabler/icons-react';
import { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router';
import { appConfig, currentUser, loginAdmin, tokenAcr } from '../lib/auth';

const ACTIVITY = ['mousemove', 'keydown', 'pointerdown', 'scroll', 'touchstart'] as const;

// Вход в админку только со вторым фактором; 30 минут без действий - повторный вход (AUTH-03).
// Сервер проверяет то же самое на каждом запросе, здесь - чтобы не показывать экран, который всё равно откажет.
export function AdminGate() {
  const [state, setState] = useState<'checking' | 'ok' | 'idle'>('checking');
  const { pathname, search } = useLocation();

  useEffect(() => {
    currentUser().then((u) => {
      if (tokenAcr(u) === appConfig().adminAcr) setState('ok');
      else void loginAdmin(pathname + search);
    });
  }, [pathname, search]);

  useEffect(() => {
    if (state !== 'ok') return;
    let last = Date.now();
    const mark = () => {
      last = Date.now();
    };
    ACTIVITY.forEach((e) => window.addEventListener(e, mark, { passive: true }));
    const timer = window.setInterval(() => {
      if (Date.now() - last > appConfig().adminIdleMin * 60_000) setState('idle');
    }, 30_000);
    return () => {
      window.clearInterval(timer);
      ACTIVITY.forEach((e) => window.removeEventListener(e, mark));
    };
  }, [state]);

  if (state === 'checking') return <Center py="xl"><Stack align="center"><Loader /><Text size="sm" c="dimmed">Проверка второго фактора…</Text></Stack></Center>;
  if (state === 'idle') {
    return (
      <Center py="xl">
        <Paper withBorder radius="lg" p="xl" maw={420}>
          <Stack align="center" ta="center">
            <ThemeIcon size={56} radius="xl" variant="light"><IconLock /></ThemeIcon>
            <Title order={3}>Сессия админки закрыта</Title>
            <Text size="sm" c="dimmed">После {appConfig().adminIdleMin} минут без действий нужно войти заново с одноразовым кодом.</Text>
            <Button onClick={() => loginAdmin(pathname + search, true)}>Войти снова</Button>
          </Stack>
        </Paper>
      </Center>
    );
  }
  return <Outlet />;
}
